import styled from "styled-components";

export const Styles = styled.div`
  .table-div__header .table-div__cell_header,
  .table-div__header .table-div__cell {
    background-color: #4e525b !important;
    color: #ffffff !important;
  }
`;
